
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/appReadme/appReadme.scss.css.virtualfile';
        module.exports = {"content":"_content_1sutk_1","container":"_container_1sutk_4"};